export default __webpack_public_path__ + "static/media/SF-Logo.16f27662.png";